import React from "react";

const Discord = () => {
  window.location.href = "https://dsc.gg/ariza";
  return <div></div>;
};

export default Discord;
